<template lang="pug">
v-card.limit-card
  div.limit-card-container(:style="{color:textColor}")
    div.icon-container
      slot(name="icon")
    div.bar-container
      div {{ textType }} limit bar
      div.font-weight-bold {{ limitCommaFormatted }} 
        span.text-lowercase {{ textType }}s/mo
      v-progress-linear.rounded-progress(:value="(remaining/limit)*100" height=12 :color="barColor")
    div.remaining-container
      div.font-weight-bold.display-1 {{ remainingCommaFormatted }}
      div.font-weight-thin Remaining 
        span.text-lowercase {{ textType }}s
</template>
    
<script>
export default {
  name: 'TextLimitsWidget',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    textType: String,
    limit: Number,
    remaining: Number,
  },
  computed: {
    limitCommaFormatted() {
      return this.limit.toLocaleString('en-US');
    },
    remainingCommaFormatted() {
      return this.remaining.toLocaleString('en-US');
    },
    barColor() {
      if (this.disabled) {
        return 'grey'
      }
      return 'primary'
    },
    textColor() {
      if (this.disabled) {
        return 'grey'
      }
      return 'black'
    }
  },
};
</script>
    
<style lang="scss" scoped>
.limit-card {
  border: 1px solid #000000;
  border-radius: 8px;
}

.limit-card-container {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.icon-container {
  width: 15%;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bar-container {
  width: 55%;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.remaining-container {
  width: 30%;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


::v-deep {
  .v-progress-linear__bar {
    border-radius: 6px;
  }

  .v-progress-linear__background {
    border-radius: 6px;
  }

  .v-progress-linear__bar__determinate {
    border-radius: 6px;
  }
}
</style>
    